import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../../../store";
import * as SocialMediaStatusActions from "../../../store/repIQSocialMediaStatus/actions";
import * as SocialMediaAnalysisHistoryAction from "../../../store/repIQSocialMediaAnalysisHistory/actions";
import * as Service from "../../../store/service";
import { DialogComponent } from "../../common/DialogComponent";
import { Notification } from "../../common/Notification";
import ConfirmDeleteSocialMedia from "./ConfirmDeleteSocialMedia";
import TwitterXIcon from "../../../Assets/images/icon-x-black.svg";

interface IProps {
    socialMediaNetwork: string;
    socialMediaNetworkID: number;
}

const SocialMedia: React.FunctionComponent<IProps> = (props) => {
    const dispatch = useDispatch();
    const getSocialMediaStatus = (forceReload: boolean) => dispatch(SocialMediaStatusActions.actionCreators.getUserNetworkStatus(forceReload));
    const isSocialMediaStatusLoading = useSelector((state: ApplicationState) => state.repIQSocialMediaStatusState && state.repIQSocialMediaStatusState.isLoading);
    const getSocialMediaAnalysisHistory = (forceReload: boolean) =>
        dispatch(SocialMediaAnalysisHistoryAction.actionCreators.getSocialMediaAnalysisHistory(forceReload));
    const [isLoading, setIsLoading] = useState(false);
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
    var win: any;

    const networkStatus = useSelector((state: ApplicationState) =>
        state.repIQSocialMediaStatusState && state.repIQSocialMediaStatusState.socialMediaStatus && state.repIQSocialMediaStatusState.socialMediaStatus.length > 0
            ? state.repIQSocialMediaStatusState.socialMediaStatus.filter((s) => s.NetworkID === props.socialMediaNetworkID)
            : []
    );

    const callBackURL = window.location.origin + "/app/rep-iq-social-media-callback";

    const showMsg = (type: string, title: string, msg: string) => {
        Notification({
            type: type,
            title: title,
            message: msg,
            duration: 5,
        });
    };

    const getSocialMediaOauthURL = () => {
        setIsLoading(true);
        Service.getSocialMediaOauthURL(props.socialMediaNetworkID, callBackURL)
            .then((data) => {
                if (data) {
                    data = JSON.parse(data);
                    addAccount(data);
                }
                setIsLoading(false);
            })
            .catch(function (error) {
                setIsLoading(false);
                showMsg("error", "Error", "OAuth URL Not Found");
            });
    };

    const popupWindow = (url: string, title: string, win: Window, width: number, height: number) => {
        const y = window.top.outerHeight / 2 + window.top.screenY - height / 2;
        const x = window.top.outerWidth / 2 + window.top.screenX - width / 2;
        return win.open(
            url,
            title,
            `resizable=yes, scrollbars=yes, toolbar=yes, menubar=no, location=no, directories=no, status=yes', width=${width}, height=${height}, top=${y}, left=${x}`
        );
    };

    const addAccount = (url: string) => {
        win = popupWindow(url, props.socialMediaNetwork, window, 600, 600);

        var timer = setInterval(function () {
            if (win.closed) {
                getSocialMediaStatus(true);
                getSocialMediaAnalysisHistory(true);
                clearInterval(timer);

                Service.getUserNetworkStatus().then((data) => {
                    if (data && data.length > 0) {
                        let status = data.filter(
                            (obj: { networkID: number; status: string }) => obj.networkID === props.socialMediaNetworkID && obj.status === "Connected"
                        );
                        if (status && status.length > 0) {
                            showMsg("success", "Success", "Your " + props.socialMediaNetwork + " account has been successfully connected to RepIQ.");
                        }
                    }
                });
            }
        }, 1000);
    };

    const drawSocialMediaIcon = (network: string) => {
        if (network === "Facebook") {
            return (
                <span role="option" className="data-icon color-facebook">
                    <img src="images/f_logo_RGB-Blue_58.png" alt="Facebook Logo" />
                </span>
            );
        } else if (network === "Instagram") {
            return (
                <span role="option" className="data-icon color-instagram">
                    <img src="images/glyph-logo_May2016.png" alt="Instagram Logo" />
                </span>
            );
        } else if (network === "LinkedIn") {
            return (
                <span role="option" className="data-icon">
                    <img src="images/LI-In-Bug.png" alt="LinkedIn Logo" />
                </span>
            );
        } else if (network === "X") {
            return (
                <span role="option" className="data-icon color-twitter">
                    <img src={TwitterXIcon} alt="X Logo" />
                </span>
            );
        }
    };

    const confirmDeletion = () => {
        setShowDeleteConfirm(true);
    };

    const handleConfirmDeletionEvent = (value: string): any => {
        setShowDeleteConfirm(false);
        if (value === "delete") {
            disconnectSocialMediaAccount();
        }
    };

    const disconnectSocialMediaAccount = () => {
        setIsLoading(true);

        Service.disconnectSocialMediaAccount(props.socialMediaNetworkID)
            .then((data) => {
                showMsg("success", "Success", "Your " + props.socialMediaNetwork + " account has been successfully disconnected from RepIQ.");
                getSocialMediaStatus(true);
                setIsLoading(false);
            })
            .catch(function (error) {
                showMsg("error", "Error", "Something went wrong. Please try again.");
            });
    };

    return (
        <React.Fragment>
            <div role="row" className="data-row row">
                <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                    <div className="data-label" id={"label-" + props.socialMediaNetwork.toLowerCase()}>
                        {props.socialMediaNetwork}
                    </div>
                </div>

                {isLoading || isSocialMediaStatusLoading ? (
                    <div className="box loading"></div>
                ) : (
                    <React.Fragment>
                        <div role="gridcell" className="col-xs-10 col-sm-6 col-no-gutter">
                            <div className="data-value has-gfx" aria-labelledby={"label-" + props.socialMediaNetwork}>
                                {drawSocialMediaIcon(props.socialMediaNetwork)}

                                {networkStatus && networkStatus.length > 0 ? (
                                    <React.Fragment>{networkStatus[0].Username}</React.Fragment>
                                ) : (
                                    <button type="button" onClick={getSocialMediaOauthURL} className="btn-default btn-link btn-no-padding btn-no-border btn-table">
                                        <span className="btn-text">Add {props.socialMediaNetwork} Account</span>
                                    </button>
                                )}
                            </div>
                        </div>
                        <div role="gridcell" className=" col-xs-2 col-sm-2 col-no-gutter flex-grow-null text-align-right">
                            <div className="form-row text-align-right">
                                <div className="form-input">
                                    <label className="form-toggle-label">
                                        {networkStatus && networkStatus.length > 0 && networkStatus[0].Status === "Connected" && (
                                            <button
                                                type="button"
                                                onClick={confirmDeletion}
                                                className="btn-default btn-secondary-outline btn-table btn-no-border btn-no-padding btn-remove-item"
                                            >
                                                <span className="btn-icon">
                                                    <em className="las la-unlink"></em>
                                                </span>
                                                <span className="btn-text" style={{ color: "#0a7087", fontWeight: "normal" }}>
                                                    Disconnect
                                                </span>
                                            </button>
                                        )}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </React.Fragment>
                )}
                {showDeleteConfirm && (
                    <DialogComponent
                        dialogId="protection-plan-upgrade-done-dialog"
                        title="Plan Upgrade Done"
                        datalayerEvent="Protection Plan - Close completion"
                        closeDialog={() => {
                            handleConfirmDeletionEvent("close");
                        }}
                    >
                        <ConfirmDeleteSocialMedia socialMediaNetwork={props.socialMediaNetwork} buttonEvent={handleConfirmDeletionEvent} />
                    </DialogComponent>
                )}
            </div>
        </React.Fragment>
    );
};
export default SocialMedia;
